export const domain = 'BrandInfo';

// action types
export const RECEIVE_BRAND_INFO = `${domain}/RECEIVE_BRAND_INFO`;
